import {ListFilterCreatedAtSection} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {CREATED_AT_FILTER_OPTIONS} from '../../config/team-filter.config';

import type {CreatedAtFilter} from '@sollapay/ui/components';
import type {FC} from 'react';

export interface TeamFilterCreatedAtSectionProps {
  createdAt: CreatedAtFilter;
  onChange: (createdAt: CreatedAtFilter) => void;
}

export const TeamFilterCreatedAtSection: FC<TeamFilterCreatedAtSectionProps> = ({
  createdAt,
  onChange
}) => {
  const {t} = useTranslation('team');

  const options = CREATED_AT_FILTER_OPTIONS.map(opt => ({value: opt.value, label: t(opt.i18nKey)}));

  return (
    <ListFilterCreatedAtSection
      sectionLabel={t('filter.sections.createdAt')}
      options={options}
      createdAt={createdAt}
      hasDateRange={false}
      onChange={onChange}
    />
  );
};
